<script lang="ts">
  import { run } from 'svelte/legacy';

  import type {IGame} from "$lib/interfaces/IGame";
  import FavoriteButton from "$lib/elements/FavoriteButton.svelte";
  import {blur} from 'svelte/transition';
  import {locale} from "$lib/i18n";
  import {lazyLoad} from "$lib/utils/lazyLoad";
  import type {IUser} from "$lib/interfaces/IUserMe";
  import {user} from "$lib//stores"
  import WarningIcon from "$lib/icons/WarningIcon.svelte";
  import {goto} from "$app/navigation";

  interface Props {
    game: IGame | null;
    slider?: boolean;
  }

  let { game, slider = false }: Props = $props();
  let localUser: IUser | null = $state(null);
  run(() => {
    localUser = $user
  });

</script>

{#if game}
  <div class="col-span-1 flex flex-col gap-2 animate-fadeIn relative"
       transition:blur|local={{ delay:150, duration: 300 }}>
    <div
        class="rounded-2xl aspect-[89/127] relative group transition-all animate-fadeIn duration-300 hover:shadow-md hover:shadow-primary-fire/20 hover:from-primary-fire bg-cover bg-center">
      {#if game.image && !slider}
        <img class="object-cover rounded-2xl aspect-[89/127]" use:lazyLoad={game.image} src="/placeholder.png"
             alt={game.name}/>
      {:else if game.image && slider}
        <img class="object-cover rounded-2xl aspect-[89/127]" data-splide-lazy={game.image} src="/placeholder.png"
             alt={game.name}/>
      {:else}
        <img class="object-cover rounded-2xl aspect-[89/127]" src="/not-found.png" alt={game.name}/>
      {/if}

      <div
          class="absolute top-0 {!game.countrySupported ? 'cursor-pointer' : ''} left-0 pt-4 opacity-0 group-hover:opacity-100 flex flex-col h-full w-full justify-center items-center rounded-2xl bg-gray-800/50 transition-all duration-100"
          onclick={() => {
            if (!game.countrySupported) {
              goto(`/${$locale}/game/${game.slug}`)
            }
          }}>
        {#if game.countrySupported}
          <a href={`/${$locale}/game/${game.slug}`} data-sveltekit-preload-data="false">
            <div
                class="bg-primary-fire rounded-full p-3 bg-gradient-to-r from-primary-fire via-primary-fire/85 to-primary-fire/70">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                   class="w-8 h-8 pl-1 text-white">
                <path fill-rule="evenodd"
                      d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z"
                      clip-rule="evenodd"/>
              </svg>
            </div>
          </a>
          {#if localUser}
            <a href="{`/${$locale}/game/${game.slug}?demo=true`}" data-sveltekit-preload-data="false" class="text-white"
               style="text-shadow: #1c2535 0 0 10px">
              Demo
            </a>
          {/if}
        {/if}
      </div>
      {#if !game.countrySupported}
        <div
            class="absolute w-full h-full text-small text-center left-0 top-0 flex justify-center items-center flex-col  text-lg text-white rounded-xl bg-black/50 pointer-events-none">
          <span>Region Restricted</span>
          <WarningIcon css="w-[56px]"/>
        </div>
      {/if}
    </div>

    <div class="flex justify-between">
      <div class="flex-col flex gap-1 w-[80%]">
        <a href={`/${$locale}/game/${game.slug}`} title={game.name} class="text-xs text-white truncate"
           data-sveltekit-preload-data="false">{game.name}</a>
        <a href={`/${$locale}/providers/${game.provider.toLowerCase()}`}
           class="text-xs text-primary-lightBlue" data-sveltekit-preload-data="false">{game.provider}</a>
      </div>
      <FavoriteButton game={game}/>
    </div>
  </div>
{/if}
